var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6A6E79",
  d: "M6.967 5.032a.747.747 0 0 0 0 1.058L9.877 9l-2.91 2.91a.747.747 0 1 0 1.058 1.057l3.442-3.442a.747.747 0 0 0 0-1.058L8.025 5.025a.754.754 0 0 0-1.058.007"
})));
export { SvgChevronRight as ReactComponent };